import { apiService } from './api';

export type OwnershipScope = 'stakeholder' | 'organization' | 'category';

export interface OwnershipAssignment {
  id: string;
  ownerId: string;
  scope: OwnershipScope;
  scopeId?: string;
  scopeValue?: string;
  assignedBy: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateOwnershipAssignmentDto {
  ownerId: string;
  scope: OwnershipScope;
  scopeId?: string;
  scopeValue?: string;
}

export const ownershipService = {
  async assign(data: CreateOwnershipAssignmentDto): Promise<OwnershipAssignment> {
    const res = await apiService.post<OwnershipAssignment>('/api/ownership/assign', data);
    return res.data;
  },

  async listAssignments(): Promise<OwnershipAssignment[]> {
    const res = await apiService.get<OwnershipAssignment[]>('/api/ownership/assignments');
    return res.data;
  },

  async myAssignments(): Promise<OwnershipAssignment[]> {
    const res = await apiService.get<OwnershipAssignment[]>('/api/ownership/my-assignments');
    return res.data;
  },

  async check(entityType: 'stakeholder' | 'organization', entityId: string) {
    const res = await apiService.get(`/api/ownership/check/${entityType}/${entityId}`);
    return res.data as { hasAccess: boolean };
  },

  async remove(id: string): Promise<void> {
    await apiService.delete(`/api/ownership/${id}`);
  },

  async transfer(fromOwnerId: string, toOwnerId: string, scope: OwnershipScope, scopeId?: string) {
    const res = await apiService.post<OwnershipAssignment>('/api/ownership/transfer', {
      fromOwnerId, toOwnerId, scope, scopeId,
    });
    return res.data;
  }
};

